const LINE_FEED = 0x0a;
const CARRIAGE_RETURN = 0x0d;
const UNIT_SEPARATOR = 0x1f;

/**
 * Strips C0 control characters (the first 32 ASCII codes, 0x00–0x1F) that have
 * no valid use in database text cell content. These are invisible legacy terminal
 * signals (NUL, BEL, ESC, etc.) that can corrupt display, break string handling
 * in downstream systems, or be used in injection attacks.
 *
 * Preserved (legitimate whitespace in multiline text):
 * - 0x0A LF  (newline)
 * - 0x0D CR  (carriage return, part of Windows \r\n line endings)
 *
 * Stripped (including some that appear whitespace-like but have no product use):
 * - 0x00–0x09  NUL, SOH, STX, ETX, EOT, ENQ, ACK, BEL, BS, HT (tab)
 * - 0x0B       VT  (vertical tab — renders inconsistently)
 * - 0x0C       FF  (form feed — triggers page breaks in some renderers)
 * - 0x0E–0x1F  SO, SI, DLE, DC1–DC4, NAK, SYN, ETB, CAN, EM, SUB, ESC, FS–US
 *
 * Tab (0x09) is stripped because database text cells do not support tab input
 * via the UI, and neither the rich text (ADF) path nor getAdfTextContentWithUrl()
 * produces tab characters. Allowing tabs only via the API would create an
 * inconsistency between what the UI can display/edit and what is stored.
 *
 * Uses charCode checks instead of a regex to avoid ESLint's no-control-regex rule.
 */
export function stripControlChars(value: string): string {
  let result = '';

  for (const char of value) {
    const code = char.charCodeAt(0);

    if (code <= UNIT_SEPARATOR && code !== LINE_FEED && code !== CARRIAGE_RETURN) {
      continue;
    }

    result += char;
  }

  return result;
}
